import { useMemo, useRef } from 'react';
import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import { useSelector } from 'react-redux';
import { StyledAccordionContainer, StyledGridContainer, StyledLeadContainer } from '../../../Components/Styled/index';
import { ACTIVE_STATUS, TASK_STATUS, TASK_PRIMARY_TYPE, TASK_SECONDARY_TYPE, TASK_SOURCE, TASK_PRIORITY, handleValidateCodevalue, STATIC_ENTITY_CONFIG } from '../../../Utility/constant';
import { WhoColumns } from '../../../Components/WhoColumns';
import TextFiledWithLabel from '../../../Components/TextFieldWithLabel';
import AutoCompleteComponent from '../../../Components/AutoCompleteComponenet';
import { getEntityColumns } from '../../../Utility/apiHelper';
import './Tasks.css';

const SearchTaskComponent = ({ handleSelectOwner,handleSelectStatus, ownerlistdropdown, entityDetails, handleOnChange }) => {
    const inputSearchRef = useRef(null);

    const internationalise = useSelector(state => state?.internationalise?.currentHashMapData);
    const taskStatusData = useSelector(state => state?.lookup?.lookupData)?.find((item) => item?.name == TASK_STATUS)?.codes?.filter(item => item?.status == ACTIVE_STATUS)?.sort((a, b) => a?.sequence - b?.sequence);
    const taskPrimaryTypeData = useSelector(state => state?.lookup?.lookupData)?.find((item) => item?.name == TASK_PRIMARY_TYPE)?.codes?.filter(item => item?.status == ACTIVE_STATUS)?.sort((a, b) => a?.sequence - b?.sequence);
    const taskSecondaryTypeData = useSelector(state => state?.lookup?.lookupData)?.find((item) => item?.name == TASK_SECONDARY_TYPE)?.codes?.filter(item => item?.status == ACTIVE_STATUS)?.sort((a, b) => a?.sequence - b?.sequence);
    const taskSourceData = useSelector(state => state?.lookup?.lookupData)?.find((item) => item?.name == TASK_SOURCE)?.codes?.filter(item => item?.status == ACTIVE_STATUS)?.sort((a, b) => a?.sequence - b?.sequence);
    const specificRolePermission = useSelector(state => state?.owner?.rolebasedData);
    const allEntityData = useSelector((state) => state?.customization?.allEntityData || []);

        const taskTextfieldsData = useMemo(() => {
            const data = getEntityColumns(allEntityData, "TASK");
            const sourceData = Object.keys(data).length > 0 ? data: STATIC_ENTITY_CONFIG?.TASK;   
            const { id, ...rest } = sourceData;
                return rest;
        }, [allEntityData]);

    return (
        <Box className="search-task-form-box">
            <StyledGridContainer>
                <TextFiledWithLabel
                    type="number"
                    name="id"
                    value={entityDetails?.id || ''}
                    label={handleValidateCodevalue(internationalise, 'TASK_SEARCH_TASK_ID')}
                    handleOnChange={handleOnChange}
                />
                <TextFiledWithLabel
                    type="number"
                    name="customerId"
                    value={entityDetails?.customerId || ''}
                    label={handleValidateCodevalue(internationalise, "TASK_EDIT_CUSTOMER")}
                    handleOnChange={handleOnChange}
                />
                <TextFiledWithLabel
                    type="number"
                    name="parentTaskId"
                    value={entityDetails?.parentTaskId || ''}
                    label={handleValidateCodevalue(internationalise, 'TASK_SEARCH_PARENT_TASK_ID')}
                    handleOnChange={handleOnChange}
                />
            </StyledGridContainer>
            <StyledAccordionContainer>
                
                <AutoCompleteComponent
                    multiple
                    className="search-task-autocomplete"
                    limitTags={3}
                    textInputStyle = {{ width: "97% !important" }}
                    optionSet={ownerlistdropdown}
                    value={entityDetails?.selectedOwner || []}
                    name="managerId"
                    placeholder={handleValidateCodevalue(internationalise, 'TASK_SEARCH_OWNER')}
                    disabled={!(specificRolePermission?.isAllTaskManage || specificRolePermission?.isTaskTeamManage)}
                    label={handleValidateCodevalue(internationalise, 'TASK_SEARCH_OWNER')}
                    isOptionEqualToValue={(option, value) => option.id === value.id}
                    onChange={(event, Owner) => handleSelectOwner(event, Owner)}
                />
                
                <AutoCompleteComponent
                    multiple
                    className="search-task-autocomplete"
                    limitTags={3}
                    textInputStyle = {{ width: "97% !important" }}
                    isLookup = {true}
                    optionSet={taskStatusData}
                    value={entityDetails?.status || []}
                    name="managerId"
                    placeholder={handleValidateCodevalue(internationalise, 'TASK_EDIT_STATUS')}
                    label={handleValidateCodevalue(internationalise, 'TASK_EDIT_STATUS')}
                    isOptionEqualToValue={(option, value) => option.id === value.id}
                    onChange={(event, Status) => handleSelectStatus(event, Status,"status")}
                />
            </StyledAccordionContainer>
            <StyledGridContainer>
                <TextFiledWithLabel
                    id="primaryType"
                    select
                    name="primaryType"
                    label={handleValidateCodevalue(internationalise, "TASK_SEARCH_PT")}
                    value={entityDetails?.primaryType || ''}
                    onChange={handleOnChange}
                >
                    {taskPrimaryTypeData?.map((option) => (
                        <MenuItem key={option?.id} value={option?.name}>
                            {handleValidateCodevalue(internationalise, option?.name)}
                        </MenuItem>
                    ))}
                </TextFiledWithLabel>
                <TextFiledWithLabel
                    id="secondaryType"
                    select
                    name="secondaryType"
                    label={handleValidateCodevalue(internationalise, "TASK_SEARCH_ST")}
                    value={entityDetails?.secondaryType || ''}
                    onChange={handleOnChange}
                >
                    {taskSecondaryTypeData?.map((option) => (
                        <MenuItem key={option?.id} value={option?.name}>
                            {handleValidateCodevalue(internationalise, option?.name)}
                        </MenuItem>
                    ))}
                </TextFiledWithLabel>
                    <TextFiledWithLabel
                    id="source"
                    select
                    name="source"
                    label={handleValidateCodevalue(internationalise, "TASK_EDIT_SOURCE")}
                    value={entityDetails?.source || ''}
                    onChange={handleOnChange}
                >
                    {taskSourceData?.map((option) => (
                        <MenuItem key={option?.id} value={option?.name}>
                            {handleValidateCodevalue(internationalise, option?.name)}
                        </MenuItem>
                    ))}
                </TextFiledWithLabel>
                <TextFiledWithLabel
                    id="priority"
                    select
                    name="priority"
                    label={handleValidateCodevalue(internationalise, "TASK_EDIT_PRIORITY")}
                    value={entityDetails?.priority || ''}
                    onChange={handleOnChange}
                >
                    {TASK_PRIORITY?.map((option) => (
                        <MenuItem key={option?.label} value={option?.label}>
                            {handleValidateCodevalue(internationalise, option?.label)}
                        </MenuItem>
                    ))}
                </TextFiledWithLabel>
                
             
            </StyledGridContainer>
            
            <StyledLeadContainer>
                 
                  <TextFiledWithLabel
                    className="search-task-description"
                    id="description"
                    name="description"
                    label={handleValidateCodevalue(internationalise, "TASK_EDIT_DESCRIPTION")}
                    value={entityDetails?.description || ''}
                    onChange={handleOnChange}
                />
                <TextFiledWithLabel className="task-hidden-field" />
                <TextFiledWithLabel className="task-hidden-field" />
            </StyledLeadContainer>
            <WhoColumns
                searchState={entityDetails}
                handleOnChange={handleOnChange}
            />
        </Box>
    );
}

export default SearchTaskComponent;
